import { render, staticRenderFns } from "./UserCreateAndUpdateFormItems.vue?vue&type=template&id=25c87373&"
import script from "./UserCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./UserCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25c87373')) {
      api.createRecord('25c87373', component.options)
    } else {
      api.reload('25c87373', component.options)
    }
    module.hot.accept("./UserCreateAndUpdateFormItems.vue?vue&type=template&id=25c87373&", function () {
      api.rerender('25c87373', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserCreateAndUpdateFormItems.vue"
export default component.exports